import { generateUtilityClass, generateUtilityClasses } from '@mui/material'

export interface ToggleButtonClasses {
  root: string
}

export type ToggleButtonClassKey = keyof ToggleButtonClasses

export function getToggleButtonUtilityClass(slot: string) {
  return generateUtilityClass('ToggleButton', slot)
}

const toggleButtonClasses: ToggleButtonClasses = generateUtilityClasses('ToggleButton', ['root'])

export default toggleButtonClasses
